import { getSiteEndpoint } from 'helpers/api';
import HtmlReactParser from 'html-react-parser';
import DOMPurify from 'dompurify';
import axios from 'axios';
import Cookies from 'js-cookie';
import { COOKIES } from 'constants/cookieNames';

export const getViewportWidth = () => Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

export const getViewportHeight = () =>
  Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

export const bodyNoScroll = {
  scrollTop: 0,
  add(breakpoint) {
    this.breakpoint = breakpoint;

    if (!breakpoint || getViewportWidth() < breakpoint) {
      this.scrollTop = window.scrollY;
      document.documentElement.classList.add('lock-scroll');

      if (typeof window.bb !== 'undefined') {
        window.bb.header.headroom.destroy();
      }
    }
  },
  remove() {
    document.documentElement.classList.remove('lock-scroll');
    window.scrollTo(0, this.scrollTop);

    if (typeof window.bb !== 'undefined') {
      window.bb.header.init();
    }
  },
};

export const markNotificationAsRead = async (notificationId, token) =>
  await axios.get(`${getSiteEndpoint()}/notification/updateReadStatus`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      notificationId,
    },
  });

export const getUnReadNotificationCount = async (setCount, token) => {
  try {
    const response = await axios.get(`${getSiteEndpoint()}/notification/unreadCount`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    setCount(response?.data);
  } catch (error) {
    setCount(0);
  }
};

export const postMultipleContactId = async (id, token) => {
  const config = {
    method: 'post',
    url: `${getSiteEndpoint()}/user/ActiveContact`,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({ ContactID: id }),
  };

  const response = await axios(config);
  if (response.status === 200) {
    Cookies.set(COOKIES.MULTI_ACCOUNTS, 'multiAccounts', { expires: 365 });
  }
  return response;
};

export const deleteNotification = async (token, idNotification, setIsLoading, setNotifications) => {
  setIsLoading(true);
  try {
    const response = await axios.delete(
      `${getSiteEndpoint()}/usernotification/delete?notificationId=${idNotification}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response) {
      getNotification(setNotifications, token, setIsLoading);
    }
  } catch (error) {
    // Error handled silently
  }
};

export const getNotification = async (
  setNotification,
  token,
  setNotifLoading,
  pageNotification,
  setPageNotification,
  setStopLoadMore
) => {
  try {
    const response = await axios.get(
      `${getSiteEndpoint()}/notification/getMyNotification/?page=${pageNotification ?? 1}&pageSize=20`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (setNotifLoading) {
      setNotifLoading(false);
      setNotification((prev) => [...prev, ...response.data]);
      setStopLoadMore(true);
      if (response?.data?.length === 20) {
        setPageNotification(pageNotification + 1);
      } else if (response?.data?.length < 20) {
        setPageNotification(1);
        setStopLoadMore(false);
      }
    }
  } catch (error) {
    if (setNotifLoading) {
      setNotifLoading(false);
    }
    setNotification([]);
  }
};

export const newUser = async (token) => {
  const config = {
    method: 'post',
    url: `${getSiteEndpoint()}/notification/newUser`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  await axios(config);
};

export const logoutApi = async (token) => {
  const config = {
    method: 'post',
    url: `${getSiteEndpoint()}/user/Logout`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  await axios(config);
};
export const loginApi = async (token) => {
  const config = {
    method: 'post',
    url: `${getSiteEndpoint()}/user/Login`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await axios(config);
    return response;
  } catch (error) {
    // Gracefully handle errors, including 401
    if (error.response) {
      return error.response;
    }
    return { status: 0, data: null, error };
  }
};

export const getUserData = async (setUserData, setMultipleContacData, token) => {
  const response = await axios.get(`${getSiteEndpoint()}/user/Contacts`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const { linkedContacts } = response.data;
  setUserData(response?.data);
  setMultipleContacData(linkedContacts);
  return linkedContacts;
};

export const getActiveContactId = async (token) => {
  return await axios.get(`${getSiteEndpoint()}/user/ActiveContact`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getMultipleContact = async (setMultipleContacData, token) => {
  const response = await axios.get(`${getSiteEndpoint()}/user/Contacts`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const { linkedContacts } = response.data;
  setMultipleContacData(linkedContacts);
  return linkedContacts;
};

export const CheckContactValid = async (id, token) => {
  const config = {
    method: 'get',
    url: `${getSiteEndpoint()}/user/Contact/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return await axios(config);
};

export const ReactHtmlParser = (input) => {
  return input ? HtmlReactParser(DOMPurify.sanitize(input)) : null;
};
